// Utility function to get the authentication token
export const getAuthToken = () => {
  // Check for different token types in order of priority
  const companyToken = localStorage.getItem('companyToken');
  const branchToken = localStorage.getItem('branchToken');
  const employeeToken = localStorage.getItem('employeeToken');
  const authToken = localStorage.getItem('authToken');
  
  return companyToken || branchToken || employeeToken || authToken;
};

// Utility function to get auth headers
export const getAuthHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};
